export default __webpack_public_path__ + "_/assets/img/event-hero-background-mobile.webp";